"use strict";
// Fixtures for artifacts
// Breaks out structures into individual exports
// and then assembles them into a larger, more coordinated
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.duplicates = exports.withoutEvidence = exports.artifacts = exports.claim = exports.remittance = exports.referral = exports.coded = exports.prediction = exports.clinical = exports.codeAssembly = exports.withSourceSystem = exports.radFoot2 = exports.radFoot = exports.addendum = exports.ModGC = exports.ModLT = exports.M19 = exports.Q66 = exports.R60 = void 0;
var enums_1 = require("../enums");
exports.R60 = {
    confidence: 0.9900000000000001,
    diagnosis_code: "R60.0",
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca4",
    evidence: [
        {
            feature: {
                uuid: "6ab69a6d-d3dd-4ef1-8131-b48a00994e5a",
                type: "ngram",
                ngram: "CT ABD/PELVIS",
                field: "body_region",
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: -1.8510916053185522
        },
        {
            feature: {
                uuid: "994dc2d3-2519-490a-ae94-450a88d4eb78",
                type: "ngram",
                ngram: "aortic endograft placement",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 631,
                        end: 821,
                        uuid: "88897bb3-9d74-4d1f-b0e3-095ii583ddc3",
                        document_id: 234325,
                        content: "aortic endograft placement",
                        level: "ngram"
                    },
                    {
                        start: 631,
                        end: 821,
                        uuid: "88897bb3-9d74-4d1f-b0e3-095bb5837777",
                        document_id: 234325,
                        content: "aortic endograft placement",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "24dde99c-2a89-4ff7-a885-f788c691d1e7",
                type: "ngram",
                ngram: "fever, cough",
                field: undefined,
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: 1.8510916053185522
        },
        {
            feature: {
                uuid: "40f9e850-e662-4c94-9838-235acc365605",
                type: "ngram",
                ngram: "contrast",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 41,
                        end: 49,
                        uuid: "7e6b2b1c-ce9a-402d-8be4-eb63541xx82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "ngram"
                    },
                    {
                        start: 41,
                        end: 49,
                        uuid: "7e6b2b1c-ce9a-402d-8be4-eb63541ff82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "sentence"
                    },
                    {
                        start: 91,
                        end: 99,
                        uuid: "6e6b2b1c-ce9a-402d-8be4-eb63541ee82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "ngram"
                    },
                    {
                        start: 91,
                        end: 99,
                        uuid: "6e6b2b1c-ce9a-402d-8be4-eb63541dd82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "sentence"
                    },
                    {
                        start: 363,
                        end: 371,
                        uuid: "9e6b2b1c-ce9a-402d-8be4-eb63541cc82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "ngram"
                    },
                    {
                        start: 363,
                        end: 371,
                        uuid: "9e6b2b1c-ce9a-402d-8be4-eb63541bb82f",
                        document_id: 234325,
                        content: "contrast",
                        level: "sentence"
                    },
                    {
                        start: 43,
                        end: 51,
                        uuid: "2e6b2b1c-ce9a-402d-8be4-eb63541aa82f",
                        document_id: 234324,
                        content: "contrast",
                        level: "ngram"
                    },
                    {
                        start: 43,
                        end: 51,
                        uuid: "2e6b2b1c-ce9a-402d-8be4-eb635419982f",
                        document_id: 234324,
                        content: "contrast",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
};
exports.Q66 = {
    confidence: 0.9900000000000001,
    diagnosis_code: "Q66.6",
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca3",
    evidence: [
        {
            feature: { uuid: "99331f2b-9dea-424c-bf64-8ef66b94731e", type: "prior" },
            score: -1.054492930037871e-5,
            type: "Prior"
        },
        {
            feature: {
                uuid: "c5b5dc26-210e-4bdc-afae-20758be67410",
                type: "ngram",
                ngram: "Helically acquired axial images...",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 118,
                        end: 180,
                        uuid: "52e97bb3-9d74-4d1f-b0e3-095mm583ddc3",
                        document_id: 234325,
                        content: "P.s. Cough congestion chest pain",
                        level: "ngram"
                    },
                    {
                        start: 118,
                        end: 180,
                        uuid: "52e97bb3-9d74-4d1f-b0e3-095nnbb583ddc3",
                        document_id: 234325,
                        content: "P.s. Cough congestion chest pain",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "884dc2d3-2519-490a-ae94-450a88d4eb78",
                type: "ngram",
                ngram: "CT ANGIO ABDOMEN",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 0,
                        end: 49,
                        uuid: "7797bb3-9d74-4d1f-b0e3-095oo583ddc3",
                        document_id: 234325,
                        content: "CT ANGIO ABDOMEN",
                        level: "ngram"
                    },
                    {
                        start: 0,
                        end: 49,
                        uuid: "7797bb3-9d74-4d1f-b0e3-095pp583ddc3",
                        document_id: 234325,
                        content: "CT ANGIO ABDOMEN",
                        level: "sentence"
                    },
                    {
                        start: 52,
                        end: 102,
                        uuid: "37f20425-a6c3-49fe-9fe1-023f4f071610",
                        document_id: 234325,
                        content: "CT ANGIO ABDOMEN",
                        level: "ngram"
                    },
                    {
                        start: 52,
                        end: 102,
                        uuid: "37f20425-a6c3-49fe-9fe1-023f4f071611",
                        document_id: 234325,
                        content: "CT ANGIO ABDOMEN",
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "7226a5b7-0615-4efa-b72c-c41c712609d9",
                type: "ngram",
                ngram: "fever, cough",
                field: "raw_reasonforvisit",
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: 1.8510916053185522
        },
        {
            feature: {
                uuid: "eef823ee-4ed1-4bff-91fe-95481a1c7a86",
                type: "ngram",
                ngram: "CT ABD/PELVIS",
                field: "body_region",
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: -1.8510916053185522
        }
    ]
};
exports.M19 = {
    confidence: 0.9900000000000001,
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca5",
    diagnosis_code: "M19.071S"
};
exports.ModLT = {
    confidence: 0.9900000000000001,
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca6",
    modifier_code: "LT"
};
exports.ModGC = {
    confidence: 0.9900000000000001,
    uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca7",
    modifier_code: "GC"
};
exports.addendum = {
    artifact_id: 14896245,
    type: "PROCESSED",
    identifier: "4568244",
    procedures: {
        automate: true,
        evidence: [],
        codes: [
            {
                procedure_id: 152343269,
                procedure_name: null,
                procedure_code: "73610",
                type: null,
                units: 1.0,
                sequence_number: 1,
                automate: true,
                confidence: 1.0,
                evidence: [],
                modifiers: {
                    confidence: -1.0,
                    automate: false,
                    evidence: [],
                    codes: [
                        {
                            modifier_code: "RT",
                            automate: false,
                            confidence: -1.0,
                            sequence_number: 1,
                            evidence: [],
                            used: true
                        },
                        {
                            modifier_code: "ADD",
                            automate: false,
                            confidence: 1.0,
                            sequence_number: 2,
                            evidence: [],
                            used: true
                        }
                    ]
                },
                diagnoses: {
                    confidence: 0.79,
                    primary_code_confidence: -1.0,
                    primary_predicted_code: null,
                    automate: true,
                    type: null,
                    evidence: [],
                    codes: [
                        {
                            diagnosis_code: "M25.471",
                            automate: false,
                            confidence: 0.79,
                            sequence_number: 1,
                            type: null,
                            evidence: [],
                            used: true
                        },
                        {
                            diagnosis_code: "S99.911A",
                            automate: false,
                            confidence: 0.79,
                            sequence_number: 2,
                            type: null,
                            evidence: [],
                            used: true
                        },
                        {
                            diagnosis_code: "S99.921A",
                            automate: false,
                            confidence: 0.79,
                            sequence_number: 3,
                            type: null,
                            evidence: [],
                            used: true
                        }
                    ]
                },
                used: true
            }
        ],
        confidence: 1.0
    },
    modifiers: {
        confidence: 1.0,
        automate: true,
        evidence: [],
        codes: []
    },
    diagnoses: {
        confidence: 0.79,
        primary_code_confidence: 0.42,
        primary_predicted_code: "M25.471",
        automate: true,
        type: null,
        evidence: [],
        codes: []
    }
};
exports.radFoot = {
    type: "PROCESSED",
    identifier: "TXN001",
    artifact_id: 2123,
    procedures: {
        confidence: 0.9900000000000001,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c34",
        automate: true,
        evidence: [],
        codes: [
            {
                procedure_code: "73630",
                type: "cpt",
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca9",
                units: 1.0,
                modifiers: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    evidence: [],
                    codes: [
                        exports.ModLT,
                        exports.ModGC,
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca8",
                            confidence: 0.9900000000000001,
                            modifier_code: "26"
                        }
                    ]
                },
                diagnoses: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    type: "icd10",
                    evidence: [],
                    codes: [exports.R60, exports.Q66, exports.M19]
                }
            }
        ]
    },
    modifiers: {
        confidence: 0.9900000000000001,
        automate: true,
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c12",
                confidence: 0.9900000000000001,
                evidence: [],
                modifier_code: "RT"
            },
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c13",
                confidence: 0.9900000000000001,
                evidence: [],
                modifier_code: "GC"
            }
        ]
    },
    diagnoses: {
        confidence: 0.9900000000000001,
        automate: true,
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c14",
                automate: true,
                confidence: 0.9900000000000001,
                evidence: [
                    {
                        details: {
                            feature: {
                                type: "ngram",
                                ngram: "chest pain",
                                field: "raw_reasonforvisit",
                                slop: 2,
                                in_order: true
                            },
                            score: 0.21478298151125555,
                            type: "Unknown"
                        },
                        type: "Unknown"
                    }
                ],
                diagnosis_code: "R16.0",
                type: "icd10"
            },
            {
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c15",
                confidence: 0.9900000000000001,
                evidence: [],
                diagnosis_code: "R10.11"
            }
        ]
    }
};
exports.radFoot2 = {
    type: "PROCESSED",
    identifier: "TXN002",
    artifact_id: 15,
    procedures: {
        confidence: 0.9900000000000001,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c35",
        automate: true,
        evidence: [],
        codes: [
            {
                procedure_code: "70330",
                type: "cpt",
                units: 1.0,
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c17",
                modifiers: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c16",
                            confidence: 0.9900000000000001,
                            modifier_code: "26"
                        }
                    ]
                },
                diagnoses: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    type: "icd10",
                    evidence: [],
                    codes: [exports.Q66]
                }
            }
        ]
    },
    modifiers: {
        confidence: 0.9900000000000001,
        automate: true,
        codes: [
            {
                confidence: 0.9900000000000001,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c18",
                evidence: [],
                modifier_code: "LT"
            },
            {
                confidence: 0.9900000000000001,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c19",
                evidence: [],
                modifier_code: "GC"
            }
        ]
    },
    diagnoses: {
        confidence: 0.9900000000000001,
        automate: true,
        codes: [
            {
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c20",
                confidence: 0.9900000000000001,
                evidence: [
                    {
                        details: {
                            feature: {
                                type: "ngram",
                                ngram: "chest pain",
                                field: "raw_reasonforvisit",
                                slop: 2,
                                in_order: true
                            },
                            score: 0.21478298151125555,
                            type: "Unknown"
                        },
                        type: "Unknown"
                    }
                ],
                diagnosis_code: "R16.0",
                type: "icd10"
            },
            {
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c21",
                confidence: 0.9900000000000001,
                evidence: [],
                diagnosis_code: "R10.11"
            }
        ]
    }
};
exports.withSourceSystem = {
    type: "CLINICAL",
    identifier: "TXN003",
    artifact_id: 342342,
    procedures: {
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c36",
        evidence: [],
        automate: true,
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c22",
                procedure_name: "",
                automate: true,
                procedure_code: "70450",
                type: "cpt",
                units: 1.0
            }
        ]
    },
    modifiers: {
        evidence: [],
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c23",
                modifier_code: "LT"
            }
        ]
    },
    diagnoses: {
        evidence: [
            {
                details: {
                    feature: {
                        type: "ngram",
                        ngram: "chest pain",
                        field: "raw_reasonforvisit",
                        slop: 2,
                        in_order: true
                    },
                    score: 0.21478298151125555,
                    type: "Unknown"
                },
                type: "Unknown"
            }
        ],
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c24",
                diagnosis_code: "R16.0"
            }
        ]
    }
};
exports.codeAssembly = {
    type: "PROCESSED",
    identifier: "TXN004",
    artifact_id: 32424234,
    procedures: {
        confidence: 0.9900000000000001,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c37",
        automate: true,
        evidence: [],
        codes: [
            {
                procedure_code: "70450",
                units: 1.0,
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c29",
                modifiers: {
                    confidence: 0,
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c25",
                            modifier_code: "LT"
                        },
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c26",
                            modifier_code: "GC"
                        }
                    ]
                },
                diagnoses: {
                    confidence: 0,
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c27",
                            diagnosis_code: "R16.0"
                        },
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c28",
                            diagnosis_code: "R10.11"
                        }
                    ]
                }
            }
        ]
    },
    modifiers: {
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c30",
                automate: true,
                confidence: 0.9900000000000001,
                evidence: [],
                modifier_code: "LT"
            },
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c31",
                automate: true,
                confidence: 0.9900000000000001,
                evidence: [],
                modifier_code: "GC"
            }
        ]
    },
    diagnoses: {
        codes: [
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c32",
                diagnosis_code: "R16.0",
                automate: true,
                confidence: 0.9900000000000001,
                type: "icd10",
                evidence: [
                    {
                        details: {
                            feature: {
                                type: "ngram",
                                ngram: "chest pain",
                                field: "raw_reasonforvisit",
                                slop: 2,
                                in_order: true
                            },
                            score: 0.21478298151125555,
                            type: "Unknown"
                        },
                        type: "Unknown"
                    }
                ]
            },
            {
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c33",
                automate: true,
                confidence: 0.9900000000000001,
                evidence: [],
                diagnosis_code: "R10.11"
            }
        ]
    }
};
exports.clinical = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.CLINICAL });
exports.prediction = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.PREDICTION });
exports.coded = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.CODED });
exports.referral = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.REFERRAL });
exports.remittance = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.REMITTANCE });
exports.claim = __assign(__assign({}, exports.codeAssembly), { type: enums_1.CaseArtifactTypes.CLAIM });
exports.artifacts = [
    exports.withSourceSystem,
    exports.radFoot,
    exports.codeAssembly
];
exports.withoutEvidence = [
    {
        artifact_id: 634123,
        type: "PREDICTION",
        identifier: "184132",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 1.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: 1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 1.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: 1.0,
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.48,
            automate: false,
            evidence: [],
            codes: [
                {
                    modifier_code: "52",
                    automate: false,
                    confidence: 0.48,
                    evidence: [],
                    used: true
                },
                {
                    modifier_code: "RT",
                    automate: false,
                    confidence: 0.48,
                    evidence: [],
                    used: true
                }
            ]
        },
        diagnoses: {
            confidence: 0.89,
            automate: true,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "Z12.31",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                },
                {
                    diagnosis_code: "Z85.3",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 634133,
        type: "PROCESSED",
        identifier: "184132",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 1.0,
                    automate: true,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "RT",
                                automate: false,
                                confidence: 1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 1.0,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "Z12.31",
                                automate: false,
                                confidence: 1.0,
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    confidence: 1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 1.0,
                    automate: true,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "RT",
                                automate: false,
                                confidence: 1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 1.0,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "Z12.31",
                                automate: false,
                                confidence: 1.0,
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    confidence: 1.0,
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.48,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.89,
            automate: true,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "Z85.3",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 631693,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 631690,
        type: "CLINICAL",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: false
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: false
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    }
];
exports.duplicates = [
    {
        artifact_id: 634123,
        type: "PREDICTION",
        identifier: "184132",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 1.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: 1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 1.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: 1.0,
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.48,
            automate: false,
            evidence: [],
            codes: [
                {
                    modifier_code: "52",
                    automate: false,
                    confidence: 0.48,
                    evidence: [],
                    used: true
                },
                {
                    modifier_code: "RT",
                    automate: false,
                    confidence: 0.48,
                    evidence: [],
                    used: true
                }
            ]
        },
        diagnoses: {
            confidence: 0.89,
            automate: true,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "Z12.31",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                },
                {
                    diagnosis_code: "Z85.3",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 634133,
        type: "PROCESSED",
        identifier: "184132",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 1.0,
                    automate: true,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "RT",
                                automate: false,
                                confidence: 1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 1.0,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "Z12.31",
                                automate: false,
                                confidence: 1.0,
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    confidence: 1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 1.0,
                    automate: true,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "RT",
                                automate: false,
                                confidence: 1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 1.0,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "Z12.31",
                                automate: false,
                                confidence: 1.0,
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    confidence: 1.0,
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.48,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.89,
            automate: true,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "Z85.3",
                    automate: false,
                    confidence: 0.89,
                    type: null,
                    evidence: [],
                    used: true
                }
            ]
        }
    },
    {
        artifact_id: 631693,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: true
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 631690,
        type: "CLINICAL",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_name: null,
                    procedure_code: "77063",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: false
                },
                {
                    procedure_name: null,
                    procedure_code: "77067",
                    type: null,
                    units: 0.0,
                    automate: false,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    confidence: -1.0,
                    used: false
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    }
];
//# sourceMappingURL=artifacts.js.map